import BaseNavBar from "./BaseNavBar";

function About(props) {
    return (
        <div className="main-layout contineer_page">
            <header>
                <BaseNavBar {...props} active='about'/>
            </header>

            <div className="backgro_mh">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="heding">
                                <h2>About</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="about" className="about">
                <div className="container">
                    <div className="row display_boxflex">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div className="about-box">
                                <h2>About Us</h2>
                                <p>For any comments or suggestions, contact by </p>
                                <p>Email- mrppa.dev@gmail.com </p>
                                <p>TP- 0094 71 520 4962 </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default About;
